/* eslint-disable */
import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Button, Container, Table } from "react-bootstrap";
import { TableVirtuoso } from 'react-virtuoso'
import DatePicker, { registerLocale } from "react-datepicker";
import Header from "../Layout/Header/Header";
import DeleteBlockHour from "../Delete/DeleteBlockHour";
import Note from "../Note/Note";
import axios from "axios";
import exportFromJSON from "export-from-json";
import BlockApointment from "../Apointment/BlockApointment";
import dayjs from "dayjs";
import es from "date-fns/locale/es";
import DaysOff from "../DaysOff/DaysOff";
import ReactLoading from 'react-loading'
import "jspdf-autotable";
import "react-datepicker/dist/react-datepicker.css";
import "../../index.css";
registerLocale("es", es);

function BlockList() {
  const { isAuth, user1 } = useContext(AuthContext);
  let [loading, setLoading] = useState(false)
  let [schedule, setSchedule] = useState([]);
  let [data1, setData1] = useState([]);
  let [data2] = useState([]);
  let order = "date";
  let excludeColumns = ["_id", "is_active", "createdAt", "updatedAt"]; // excluye datos del arreglo del filtro
  let URL_GET_SCHEDULE = `${process.env.REACT_APP_API}${user1.role === "doctor" ? "schedulesbydoctor" : user1.role === "admin" ? "schedules" : null}/${user1.id}/${user1.role === "doctor" ? user1.id : user1.role === "admin" ? "" : null}`;
  let [dataxls, setDataxls] = useState([]);
  let [startDate, setStartDate] = useState(null);

  useEffect(() => {
    setLoading(true)
    if (user1.role !== undefined) {
      axios
        .get(URL_GET_SCHEDULE, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => (setSchedule(data.data), setData1(data.data), setLoading(false)))
        .catch((err) => console.log(err));
    }
  }, [user1]);

  const toFind = (selectedDay) => {
    filterData(`${dayjs(selectedDay).format("YYYY-MM-DD")}T`);
  };

  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue === "") setData1(schedule);
    else {
      const filteredData = schedule.filter((item) => {
        return Object.keys(item).some((key) =>
          excludeColumns.includes(key)
            ? false
            : String(item[key]).toLowerCase().includes(lowercasedValue)
        );
      });
      setData1(filteredData);
    }
  };

  const Todas = () => {
    setData1(schedule);
  };

  const sortJSON = (json, key, orden) => {
    // eslint-disable-next-line
    return json.sort(function (a, b) {
      var x = a[key],
        y = b[key];

      if (orden === "asc") {
        return x < y ? -1 : x > y ? 1 : 0;
      }

      if (orden === "desc") {
        return x > y ? -1 : x < y ? 1 : 0;
      }
    });
  };

  sortJSON(data1, order, "asc");

  const data = dataxls;
  const fileName = "HorasLibres";
  const exportType = "csv";

  const xls = () => {
    exportFromJSON({ data, fileName, exportType });
  };

  useEffect(() => {
    data1.map((date) => {
      const fecha = new Date(date.date).valueOf();
      const now = Date.now();
      if (fecha >= now) {
        data2.push(date);
      }
    });

    let inf = data2.filter((v) => v.type === false);
    let date = inf.map((v) => `${dayjs(v.date).format("DD-MM-YYYY")}`);
    let time = inf.map((v) => v.time);
    let docfna = inf.map((v) => v.profesional[0].nombre);
    let doclna = inf.map((v) => v.profesional[0].apellido);

    let datos = [];

    for (var i = 0; i < date.length; i++) {
      datos.push({
        Fecha: date[i],
        Hora: time[i],
        NombreDr: docfna[i],
        ApellidoDr: doclna[i],
      });
      setDataxls(datos);
    }
  }, [data1]);

  return (
    <>
      {isAuth ? (
        <>
          {user1.role === "admin" || user1.role === "doctor" || user1.role === "secre" ?
            <>
              <Header />

              <br />

              <div className="row">
                <div style={{ zIndex: 1000 }} className="col"><DatePicker className="picker" calendarStartDay={0} locale="es" todayButton="Hoy" placeholderText="Selecciona la Fecha" selected={startDate} dateFormat="dd/MM/yyyy" onChange={(date) => toFind(date)} /></div>

                <div className="col"><Button variant="success" onClick={Todas}>Ver todas las horas libres</Button></div>

                <div className="col"><BlockApointment /></div>

                <div className="col"><DaysOff /></div>

                <div className="col">
                  <Button
                    variant="outline-success rounded-circle"
                    onClick={xls}
                  >
                    {" "}
                    <i className="far fa-file-excel"></i>
                  </Button>
                </div>

              </div>

              <div className="seccion1">
                <Container className="themed-container" fluid={true}>
                  <div className="filtros">
                    {user1.role === "doctor" ?
                      <>
                        <div style={{ marginBottom: "10px" }}>
                        </div>
                      </>
                      : null}
                  </div>

                  {loading ?
                    <center>
                      <div className='loading'><ReactLoading type={'spin'} color={'cornflowerblue'} height={'5vw'} width={'5vw'} /></div>
                    </center>
                    :
                    <TableVirtuoso
                      style={{ height: "70vh", zIndex: 0 }}
                      components={{ Table: ({ style, ...props }) => <Table hover {...props} style={{ ...style, width: "100%" }} /> }}
                      data={data1.filter((date) => { const fecha = new Date(date.date).valueOf(); const now = Date.now(); return date.type === false && fecha >= now })}
                      fixedHeaderContent={() => (
                        <tr>
                          <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Fecha</th>
                          <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Hora</th>
                          {user1.role === "doctor" ? null :
                            <>
                              <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Apellido Dr.</th>
                              <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Nombre Dr.</th>
                            </>}
                          <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Nota</th>
                          <th style={{ textAlign: 'center', backgroundColor: 'white' }}>Cancelar</th>
                        </tr>
                      )}
                      itemContent={(index, date) => (
                        <>
                          <td style={{ textAlign: 'center', maxWidth: '3vw', minWidth: '3vw' }}>{`${dayjs(date.date).format("DD-MM-YYYY")}`}</td>
                          <td style={{ textAlign: 'center', maxWidth: '3vw', minWidth: '3vw' }}>{date.time}</td>
                          {user1.role === "doctor" ? null :
                            <>
                              <td style={{ textAlign: 'center', maxWidth: '3vw', minWidth: '3vw' }}>{date.profesional[0].nombre}</td>
                              <td style={{ textAlign: 'center', maxWidth: '3vw', minWidth: '3vw' }}>{date.profesional[0].apellido}</td>
                            </>
                          }
                          <td style={{ textAlign: 'center', maxWidth: '3vw', minWidth: '3vw' }}>{<Note note={date.note} />}</td>
                          <td style={{ textAlign: 'center', maxWidth: '3vw', minWidth: '3vw' }}>{<DeleteBlockHour id={date._id} datee={date.date} timee={date.time} />}</td>
                        </>
                      )}

                    />
                  }
                </Container>
              </div>
            </>
            : null}
        </>
      ) : undefined}
    </>
  );
}

export default BlockList;